export function PageHeader({ title, subtitle, children, eyebrow }) {
  return (
    <div className="border-b border-border bg-white px-6 lg:px-10 py-6">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          {eyebrow && (
            <div className="text-[10px] tracking-[0.2em] uppercase font-semibold text-[#64748B] mb-2">
              {eyebrow}
            </div>
          )}
          <h1 className="font-display text-3xl lg:text-4xl tracking-tight font-medium text-[#0F172A]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-1 text-sm text-[#475569] max-w-2xl">{subtitle}</p>
          )}
        </div>
        {children && <div className="flex items-center gap-2 flex-wrap">{children}</div>}
      </div>
    </div>
  );
}

export function PageBody({ children, className = "" }) {
  return <div className={`px-6 lg:px-10 py-8 ${className}`}>{children}</div>;
}

export function StatCell({ label, value, hint, accent, testId }) {
  return (
    <div className="p-5 lg:p-6 bg-white" data-testid={testId}>
      <div className="text-[10px] tracking-[0.2em] uppercase font-semibold text-[#64748B]">{label}</div>
      <div className={`mt-3 font-display text-3xl lg:text-4xl tracking-tight font-medium ${accent || "text-[#0F172A]"}`}>
        {value}
      </div>
      {hint && <div className="mt-1 text-xs text-[#475569]">{hint}</div>}
    </div>
  );
}

export function Section({ title, action, children, dense = false }) {
  return (
    <section className="bg-white border border-border rounded-sm">
      <div className="px-5 py-3 flex items-center justify-between border-b border-border">
        <h3 className="text-sm font-medium tracking-tight text-[#0F172A]">{title}</h3>
        {action}
      </div>
      <div className={dense ? "" : "p-5"}>{children}</div>
    </section>
  );
}
